export const statusErrors = [400, 401, 403, 404, 408, 500]

export const CODE_TIMEOUT = 'ERR-440'
